import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { EcbCourseKind, EcbOccurrence, EcbOccurrenceOptions, UnifiedCartService } from '../../services/unified-cart/unified-cart.service';

@Component({
  selector: 'app-occurrence-picker',
  templateUrl: './occurrence-picker.component.html',
  styleUrls: ['./occurrence-picker.component.scss']
})
export class OccurrencePickerComponent implements OnInit {
  @Input() kind: EcbCourseKind = 'SHORT';
  @Input() courseId = 0;
  @Output() closed = new EventEmitter<void>();
  loading = true;
  error = '';
  selectedId: number | null = null;
  options: EcbOccurrenceOptions | null = null;

  constructor(private cart: UnifiedCartService, private router: Router) {}
  ngOnInit(): void {
    this.cart.getOccurrences(this.kind, this.courseId).subscribe({
      next: data => { this.loading = false; this.options = data; this.selectedId =
        data.occurrences.filter(x => x.seatsAvailable > 0 && x.price > 0).length === 1 ? data.occurrences.find(x => x.seatsAvailable > 0 && x.price > 0)!.id : null; },
      error: e => { this.loading = false; this.error = e?.error?.message || 'Unable to load course dates.'; }
    });
  }
  canBook(entry: EcbOccurrence): boolean { return entry.seatsAvailable > 0 && entry.price > 0; }
  get selected(): EcbOccurrence | undefined {
    return this.options?.occurrences.find(x => x.id === this.selectedId);
  }
  add(): void {
    if (!this.options || !this.selected) return;
    this.error = this.cart.add(this.options, this.selected);
    if (!this.error) this.closed.emit();
  }
  addAndViewCart(): void {
    if (!this.options || !this.selected) return;
    this.error = this.cart.add(this.options, this.selected);
    if (!this.error) { this.closed.emit(); this.router.navigate(['/cart']); }
  }
}
